import React from 'react';
import { Panel } from 'react-bootstrap';

import GoogleMapReact from 'google-map-react';
import EventMapMarker from '../EventMapMarker';
import EventMapItem from '../EventMapItem';

class MapWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }
  onSelect = (eventId) => {
    this.setState({ selected: eventId });
  }
  render() {
    const stops = this.props.tour.tour_stops;
    if (stops.length === 0) {
      return null;
    }

    const mapStays = [];
    const cardStays = [];

    let currentStop = stops[0];
    const centerXY = {
      lat: currentStop.place.position.coordinates[1],
      lng: currentStop.place.position.coordinates[0],
    };
    for (let i = 0; i < stops.length; i++) {
      currentStop = stops[i];
      let eventName = currentStop.name;
      let eventType = currentStop.event_type;
      if (currentStop.events && currentStop.events.length > 0) {
        eventName = currentStop.events[0].name;
        eventType = currentStop.events[0].event_type;
      }
      // console.log("currentStop: ", i, currentStop.id);
      let nextStop = null;
      if (i+1 < stops.length) {
        nextStop = stops[i+1];
      }
      if (currentStop.id === this.state.selected) {
        centerXY.lat = currentStop.place.position.coordinates[1];
        centerXY.lng = currentStop.place.position.coordinates[0];
      }
      const index = currentStop.events.findIndex(event => event.event_type === 'show');
      if (index > -1) {
        cardStays.push((
          <EventMapItem
            key={currentStop.id}
            event={currentStop}
            eventName= {eventName}
            eventType= {eventType}
            selected={currentStop.id === this.state.selected}
            onSelect={this.onSelect}
          />
        ));
        mapStays.push((
          <EventMapMarker
            key={currentStop.id}
            event={currentStop}
            nextEvent={nextStop}
            lat={currentStop.place.position.coordinates[1]}
            lng={currentStop.place.position.coordinates[0]}
            selected={currentStop.id === this.state.selected}
            onSelect={this.onSelect}
          />
        ));  
      }
      
    }
    const listStyle = { overflowY: 'auto', maxHeight: 590 };
    const style = {backgroundColor:'green',color: '#fff',fontSize:'16px',fontWeight:'500', padding:'10px 15px'};
    return (
      <div className="col-sm-12">
        <Panel>
          <div className="col-sm-4" style={{ height: 600 }} >
           <p style={style}>Events</p>
            <ul style={listStyle}>
              {cardStays}
            </ul>
          </div>
          <div className="col-sm-8" style={{ height: 600 }}>
            <p style={style}>Map</p>
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0' }}
              defaultZoom={7}
              center={centerXY}
            >
              {mapStays}
            </GoogleMapReact>
          </div>
        </Panel>
      </div>
    );
  }
}
export default MapWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/MapWidget.js